import React from "react";
import PropTypes from "prop-types";
import Modal from 'react-bootstrap/Modal';
import Button from "../common/Button";
import successCheck from "../../svg/successCheck.svg";
import modalClose from "../../svg/modal-close.svg";
import "./formModal.scss";
const SuccessModal = (props) => {
    const { show, handleClose, closebutton, modalHeading, submitButtonTitle, onSubmit, disabled, upperInformationText, lowerInformationText  } = props
    return (
        <Modal show={show} onHide={handleClose} className="success-modal" centered>
            <Modal.Header closeButton={closebutton} className="justify-content-center">
                <div className="header-before">
                    <img src={successCheck} alt="success" />
                </div>
                <Modal.Title>{modalHeading}</Modal.Title>
            </Modal.Header>
            <div className="text-center label mt-2" dangerouslySetInnerHTML={{ __html: upperInformationText }}/>
            <div className="text-center label mt-1">
                {lowerInformationText}
                {/* Please set up your profile to continue with us for a better experience. */}
            </div>
            <Modal.Body></Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button title={submitButtonTitle} disabled={disabled} type='button' handleClick={onSubmit} />
            </Modal.Footer>
        </Modal>
    );
};
SuccessModal.propTypes = {
    show: PropTypes.bool,
    closebutton: PropTypes.bool,
    // children: PropTypes.node.isRequired,
    handleClose: PropTypes.func,
    modalHeading: PropTypes.string,
    submitButtonTitle: PropTypes.string,
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    lowerInformationText: PropTypes.string,
    upperInformationText: PropTypes.string
};

SuccessModal.defaultProps = {
    show: false,
    closebutton: false,
    modalHeading: '',
    submitButtonTitle: '',
    onSubmit: () => null,
    handleClose: () => null,
    disabled: false,
    lowerInformationText: '',
    upperInformationText: ''
};

export default SuccessModal;
